module.exports = __webpack_public_path__ + "img/job_examine08.80934efd.png";